import React from 'react';

function PlusSignIcon() {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.4081 0H19.5918V40H20.4081V0Z" fill="black"/>
            <path d="M40 20.4081V19.5918L0 19.5918V20.4081L40 20.4081Z" fill="black"/>
        </svg>
    )
}

export default PlusSignIcon;